import { lazy } from "react";
import { Route, Switch } from "react-router-dom";

const FDWebsiteSetupWizardPage = lazy(
  () => import("../../pages/FDWebsiteSetupWizardPage")
);

export function JocelynTeresRoutes() {
  return (
    <Switch>
      <Route
        path="/jt/fd-website-setup-wizard"
        component={FDWebsiteSetupWizardPage}
      />
    </Switch>
  );
}

export const slug = "jt";
